import { find, map } from "lodash";
import { getAllLocales } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import { getTimezones } from "@tootools/date";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { WizardTemplate } from "@radarly/models/insight-pages/wizard/model";
import { WizardPropertiesConfiguration } from "@radarly/models/insight-pages/wizard/model/configuration";

const TIMEZONES = map(getTimezones(), (timezone: Timezone) => ({
  value: timezone,
  label: timezone,
}));
const LOCALES = map(getAllLocales(), ({ id, label }) => ({ value: id, label }));

function getTimezoneOption(option: string) {
  return find(TIMEZONES, { value: option });
}

function getLocaleOption(option: string) {
  return find(LOCALES, { value: option });
}

export function useWizardAdvancedConfiguration({
  template,
  wizardAdvancedFormConfiguration,
}: {
  template: WizardTemplate;
  wizardAdvancedFormConfiguration: WizardPropertiesConfiguration;
}) {
  const locale = useCurrentUserLocale();

  return {
    ...wizardAdvancedFormConfiguration,
    size: "m" as const,
    form: {
      timezone: {
        label: tr(locale, "INSIGHT_PAGE_WIZARD::CONFIGURATION_TIMEZONE_LABEL"),
        placeholder: tr(
          locale,
          "INSIGHT_PAGE_WIZARD::CONFIGURATION_TIMEZONE_PLACEHOLDER"
        ),
        options: TIMEZONES,
        getOption: getTimezoneOption,
      },
      locale: {
        label: tr(locale, "INSIGHT_PAGE_WIZARD::CONFIGURATION_LANGUAGE_LABEL"),
        placeholder: tr(
          locale,
          "INSIGHT_PAGE_WIZARD::CONFIGURATION_LANGUAGE_PLACEHOLDER"
        ),
        options: LOCALES,
        getOption: getLocaleOption,
      },
      description: {
        label: tr(
          locale,
          "INSIGHT_PAGE_TEMPLATE::CONFIGURATION_DESCRIPTION_LABEL"
        ),
        placeholder: tr(
          locale,
          "INSIGHT_PAGE_TEMPLATE::CONFIGURATION_DESCRIPTION_PLACEHOLDER"
        ),
      },
    },
  };
}
